import { RecentlyDeleted } from "features/recently-deleted/ui/RecentlyDeleted"



export const RecentlyDeletedPage = () => {
  return (
    <RecentlyDeleted />
  )
} 